import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from "react-helmet";

class SeoTags extends Component {
  render() {
    const { title, sharingImage, description, currentUrl } = this.props;
    const completeTitle = title + ' - ' + window.baseTitle;

    return (
      <Helmet>
          <title>{completeTitle}</title>
          <meta name="description" content={description}/>
          <meta property="og:title" content={completeTitle}/>
          <meta property="og:image" content={'http:' + sharingImage}/>
          <meta property="og:description" content={description}/>
          <meta property="og:type" content="website"/>
          <meta property="og:url" content={currentUrl}/>
          <meta name="twitter:image:alt" content={completeTitle}/>
          <meta name="twitter:title" content={completeTitle}/>
          <meta name="twitter:description" content={description}/>
          <meta name="twitter:image" content={sharingImage}/>
          <meta name="twitter:card" content="summary_large_image"/>
          <meta name="twitter:site" content="@replaceme"/>
          <link rel="canonical" href={currentUrl}/>
      </Helmet>
    );
  }
}

SeoTags.propTypes = {
  title: PropTypes.string.isRequired,
  sharingImage: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  currentUrl: PropTypes.string.isRequired
}

export default SeoTags;



// WEBPACK FOOTER //
// ./src/components/seo/seo.jsx